require('property/share-mail');

$('.details-content--eng-btn').on('click', function() {
  $('.details-content--eng-content').slideToggle();
});

// The slider being synced must be initialized first

// FIN SLIDER


var mapLib = require('map/map');

var mapCreated = false;

$('a.geoloc').on('shown.bs.tab', function(e) {
  if(!mapCreated) {
    mapCreated = true;
    displayMap();
  }
});

function displayMap() {
  var map = new mapLib.megAgenceMap();
  map.initialize('propertyMap');

  var mapHolder = $('#propertyMap');
  var properties = [
  {
    id : mapHolder.data('propertyid'),
    center : new google.maps.LatLng(mapHolder.data('latitude'),mapHolder.data('longitude'))
  }
  ];

  map.setProperties(properties);
}


// function resizeImgAnnonces () {
//   var tabimg = $('.fancybox img');
//   for (var i = 0; i < tabimg.length; i++) {
//     if ($(tabimg[i]).width() > $(tabimg[i]).height()) {
//       $(tabimg[i]).css("width", "100%");
//       $(tabimg[i]).css("margin-top", ($(".slides").height()-$(tabimg[i]).height())/2);
//     }
//   };
// }
// $(window).resize(function() {
//   resizeImgAnnonces();
// });

// $(window).load(function() {
//   resizeImgAnnonces();
// });
